/**
 * @module interface
 */
export interface V2TimValueCallback<T> {
    code: number;
    desc: string;
    data?: T;
}
